import styles from './styles.module.scss';
import { Icon, IconID } from 'packages/radiant-react/icon';
import { Typography } from 'packages/radiant-react/typography';
import { Horizontal, Vertical } from 'packages/radiant-react/layout';
import { PROMPT_TEMPLATES, WELCOME_HEADING, WELCOME_MESSAGE } from 'components/AiMode/constants';

function ChatWelcome({ updateUserInput }: { updateUserInput: (template: string) => void }) {
  return (
    <Vertical className={styles['container']}>
      <Vertical
        className={styles['heading-and-message']}
        hAlignContent="center"
        spacing="c"
        grow={1}
      >
        <Icon id={IconID.SPOTTER_CODE} className={styles['spotter-code-landing-icon']} />
        <Typography variant="section-label">{WELCOME_HEADING}</Typography>
        <Typography variant="body-normal" className={styles['message']}>
          {WELCOME_MESSAGE}
        </Typography>
      </Vertical>
      <Vertical className={styles['prompt-templates']}>
        {PROMPT_TEMPLATES.map((template) => (
          <Horizontal
            className={styles['prompt-template']}
            key={template}
            onClick={() => updateUserInput(template)}
          >
            <Typography variant="body-normal" className={styles['prompt-template-text']}>
              {template}
            </Typography>
          </Horizontal>
        ))}
      </Vertical>
    </Vertical>
  );
}

export default ChatWelcome;
